export function checkCookiebot() {
  return typeof Cookiebot !== 'undefined' && Cookiebot !== undefined;
}
